const CURP_RE =
  /^([A-Z][AEIOUX][A-Z]{2}[0-9]{2}(?:0[1-9]|1[012])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;

export function hasCurpFormat(value: string): boolean {
  return CURP_RE.test(value);
}
